import Image from "next/image";
import { FC } from "react";

import { ConnectAccount, UserConnectChargeEnable, UserLoginStatus } from "@/apis/clients";
import { Button } from "@/components/atoms/buttons/Button";
// import { ButtonText } from "@/components/atoms/buttons/ButtonText";
import { AccountsListCard } from "@/components/organisms/accounts/AccountsListCard";
import { CreditStatusLabel } from "@/components/organisms/accounts/index/CreditStatusLabel";

interface Props {
  connectAccount: ConnectAccount;
  handleCreateConnectAccount: () => void | Promise<void>;
  handleDeleteConnectAccount: () => void | Promise<void>;
}

export const StripeConnectInfo: FC<Props> = ({
  connectAccount,
  handleCreateConnectAccount,
  handleDeleteConnectAccount,
}) => {
  if (connectAccount.user_login_status !== UserLoginStatus.MASTER) {
    return <></>;
  }

  const isStripeConnected = !!connectAccount.user_payment_setting?.stripe_id && (!!connectAccount.user_payment_setting?.is_use_jcb || !!connectAccount.user_payment_setting?.is_use_visa);

  const isConnectApplying = () => {
    return (
      connectAccount.user_payment_setting &&
      !!connectAccount.user_payment_setting.stripe_connect_id
    );
  };

  const isChargeEnabled = () => {
    return (
      connectAccount.user_payment_setting &&
      connectAccount.user_payment_setting.charges_enabled ==
      UserConnectChargeEnable.ENABLED
    );
  };


  const connectTitle = (text: string) => {
    return (
      <>
        {text}
        {/* {isChargeEnabled() && (
          <ButtonText
            type="button"
            label="解除する"
            color="accent"
            className="md:hidden"
            onClick={handleDeleteConnectAccount}
          />
        )} */}
      </>
    );
  };

  const creditStatus = () => {
    return isConnectApplying() ? (
      <ul className="mt-4">
        <li className="flex gap-2">
          <CreditStatusLabel
            isUse={connectAccount.user_payment_setting?.is_use_visa}
          />
          <div className="font-bold">VISA&nbsp;/&nbsp;MASTERCARD(R)</div>
        </li>
        <li className="flex gap-2 mt-2">
          <CreditStatusLabel
            isUse={connectAccount.user_payment_setting?.is_use_jcb}
          />
          <div className="font-bold">
            JCB&nbsp;/&nbsp;Discover&nbsp;/&nbsp;Diner’s&nbsp;Club
          </div>
        </li>
      </ul>
    ) : (
      <div className="mt-2">
        <Image
          src="/user/img/credit-icons-connect.png"
          width={210}
          height={42}
          alt="credit icon"
        />
      </div>
    );
  };

  const editLink = () => {
    return isChargeEnabled() ? (
      // <ButtonText
      //   type="button"
      //   label="解除する"
      //   color="accent"
      //   className="invisible md:visible"
      //   onClick={handleDeleteConnectAccount}
      // />
      <></>
    ) : isConnectApplying() ? (
      <Button
        type="button"
        label="カード決済申請ページへ"
        size="sm-fix"
        spSize="lg-fix"
        className="mt-4 md:mt-0"
        onClick={handleCreateConnectAccount}
      />
    ) : (
      <Button
        type="button"
        label="カード決済申請へ進む"
        size="sm-fix"
        spSize="lg-fix"
        className="mt-4 md:mt-0"
        onClick={handleCreateConnectAccount}
      />
    );
  };

  const connectInfo = () => {
    return (
      <ul className="flex-row gap-2 items-center md:flex">
        <li className="flex-auto">

          {isStripeConnected ?
            <>
              <p>本決済は Stripe により処理されます。</p>
              <p>Stripe の審査やシステム状況により、決済が完了しない・支払いが保留となる場合があります。</p>
              <p>決済や支払いに関する詳細は、Stripe へお問い合わせください。</p>
            </>
            :
            <p>クレジットカード決済の利用には審査が必要です</p>
          }
          {creditStatus()}
        </li>
        <li className="flex-none text-right md:w-[186px]">{editLink()}</li>
      </ul>
    );
  };

  const Lists = [
    {
      dt: connectTitle("クレジットカード利用申請"),
      dd: connectInfo(),
    },
  ];
  return <AccountsListCard title="クレジットカードの決済設定" list={Lists} />;
};
